import { useGetConversationById } from '../lruConversation';
import { clearKnowledgeQuery } from 'services/api/supplementKnowledge';
import { UserDB } from 'lib/db';
import { logger } from 'services/logger';
import { eventBus } from 'services/eventBus';
import { useRef } from 'react';
import { useMemoizedFn } from 'ahooks';

export const useClearKnowledgeQuery = () => {
  const isClearing = useRef(false);
  const getConversationById = useGetConversationById();

  return useMemoizedFn(async (conversationId: string) => {
    if (isClearing.current) {
      return;
    }
    const conversation = getConversationById(conversationId);
    if (conversation) {
      isClearing.current = true;
      logger.info(`[useClearKnowledgeQuery] conversationId:${conversationId}`);
      await clearKnowledgeQuery(conversationId);
      await UserDB.instance?.qaPair.delete(conversationId);
      eventBus.emit('QAPAIR_CONV_KNOWLEDGE_QUERY_REFETCH', conversationId);
      isClearing.current = false;
    }
  });
};

export const useKnowledgeQueryCount = () => {
  const increaseKnowledgeQueryCount = async (conversationId: string) => {
    try {
      const cancelCount = (await UserDB.instance?.qaPair.get(conversationId))?.cancelCount || 0;
      const newCancelCount = cancelCount + 1;
      // 使用 put 方法实现 upsert：如果表中有数据就更新，没有则插入新数据
      await UserDB.instance?.qaPair.put({
        conversationId,
        cancelCount: newCancelCount,
      });
      return newCancelCount;
    } catch (err) {
      return 1;
    }
  };

  const getKnowledgeQueryCount = async (conversationId: string) => {
    try {
      const cancelCount = (await UserDB.instance?.qaPair.get(conversationId))?.cancelCount || 1;
      return cancelCount;
    } catch (err) {
      return 1;
    }
  };

  return {
    increaseKnowledgeQueryCount,
    getKnowledgeQueryCount,
  };
};

export const useIncreaseKnowledgeQueryCount = () => {
  return async (conversationId: string) => {
    try {
      if (import.meta.env.DEV) {
        return 1;
      }

      const cancelCount = (await UserDB.instance?.qaPair.get(conversationId))?.cancelCount || 0;
      const newCancelCount = cancelCount + 1;
      // 使用 put 方法实现 upsert：如果表中有数据就更新，没有则插入新数据
      await UserDB.instance?.qaPair.put({
        conversationId,
        cancelCount: newCancelCount,
      });
      return newCancelCount;
    } catch (error) {
      console.error('数据库操作失败:', error);
    }
  };
};
